var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[(_vm.title)?_c('b-row',[_c('b-col',[_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.title))]),_c('hr',{staticClass:"m-t-0 m-b-30"})])],1):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }